import { ArrayFieldTemplateItemType } from '@rjsf/utils';
import React from 'react';
import styled from 'styled-components';

const ArrayFieldItem = styled.div`
  border: ${({ theme }) => `${theme.colors.Tarpon} solid 1px`};
`;

const ArrayFieldItemContainer = styled.div`
  padding: 10px;
`;

const RemoveButtonContainer = styled.div`
  float: right;
`;

/**
 * Function responsible to remove -<index> from a camelCase string.
 * Eg: removalInformation-0 is formatted to REMOVAL INFORMATION
 *
 * replace(/([a-z])([A-Z])/g, '$1 $2') - Captures a group of lowerCase and UpperCase chars
 * and we replace it by adding a space in between.
 * @param itemTitle the camelCase string with an index
 * @returns camelCase string splitted by a space and in caps. Eg: CAMEL CASE
 */
export const formatCamelCase = (itemTitle: string): string => {
  return itemTitle
    .split('-')[0]
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .toUpperCase();
};

/**
 * Render the representation of a single item in an array.
 * @see https://rjsf-team.github.io/react-jsonschema-form/docs/advanced-customization/custom-templates/#arrayfielditemtemplate
 * @returns Layout for rendering a single array item.
 */
export const ArrayFieldItemTemplate = (props: ArrayFieldTemplateItemType) => {
  const {
    children,
    className,
    registry,
    hasRemove,
    onDropIndexClick,
    index,
    disabled,
    uiSchema,
  } = props;

  const removalInformation =
    uiSchema?.['ui:placeholders']?.['ui:section']?.['ui:sectionHeaderText'] ??
    formatCamelCase(children.props.name);

  const { RemoveButton } = registry.templates.ButtonTemplates;
  let modifiedProps = {
    props: {
      ...children.props,
      name: removalInformation,
    },
  };
  let childrenWithUpdatedProps = { ...children, ...modifiedProps };
  return (
    <ArrayFieldItem>
      <ArrayFieldItemContainer>
        <div className={className}>
          <RemoveButtonContainer>
            {hasRemove && (
              <RemoveButton
                onClick={onDropIndexClick(index)}
                uiSchema={uiSchema}
                registry={registry}
                disabled={disabled}
              />
            )}
          </RemoveButtonContainer>
          {childrenWithUpdatedProps}
        </div>
      </ArrayFieldItemContainer>
    </ArrayFieldItem>
  );
};
